import type { PlaylistKey } from '@/components/site/SpotifyPlaylist';

/** Site sections that have their own category page. Also the `section` value of `/api/posts`. */
export type CategorySlug = 'hardstyle' | 'hardtechno' | 'culture';

export interface CategoryConfig {
  slug: CategorySlug;
  path: string;
  title: string;
  subtitle: string;
  seoDescription: string;
  emptyText: string;
  /** Spotify playlist shown below the posts / under the category's articles */
  playlist?: PlaylistKey;
}

export const CATEGORIES: CategoryConfig[] = [
  {
    slug: 'hardstyle',
    path: '/hardstyle',
    title: 'Hardstyle',
    subtitle: 'Legfrissebb hardstyle hírek és cikkek',
    seoDescription:
      'A legfrissebb hardstyle hírek, show-beszámolók és event ajánlók Magyarországon. Euphoric, raw és minden, ami hardstyle!',
    emptyText: 'Jelenleg nincsenek hardstyle cikkek.',
    playlist: 'hardstyle',
  },
  {
    slug: 'hardtechno',
    path: '/hard-techno',
    title: 'Hard Techno',
    subtitle: 'Friss hírek, megjelenések és interjúk a hard techno világából',
    seoDescription:
      'Magyarország legfrissebb hard techno híroldala. Show-ajánlók, artist interjúk, megjelenések és playlist-ek a hazai és nemzetközi hard techno színtérről.',
    emptyText: 'Jelenleg nincsenek hard techno cikkek.',
    playlist: 'hardtechno',
  },
  {
    slug: 'culture',
    path: '/culture',
    title: 'Kultúra',
    subtitle: 'Túl a stílusokon, napjaink zenei kultúrájának legégetőbb kérdései',
    seoDescription:
      'Kultúra hírek, interjúk és cikkek a hazai és nemzetközi hard music színtérről. Művészportrék, rendezvénykritikák és kulturális tartalmak.',
    emptyText: 'Jelenleg nincsenek kultúra cikkek.',
  },
];

const normalize = (category: string) => category.toLowerCase().replace(/[\s-]+/g, '');

/** The site section a post's category belongs to (used for the menu highlight, playlist and links). */
export function getCategoryForPost(category?: string): CategoryConfig | undefined {
  if (!category) return undefined;
  const normalized = normalize(category);
  const find = (slug: CategorySlug) => CATEGORIES.find((c) => c.slug === slug);
  if (normalized.includes('hardtechno')) return find('hardtechno');
  if (normalized.includes('hardstyle')) return find('hardstyle');
  if (
    normalized.includes('kultúra') ||
    normalized.includes('kultura') ||
    normalized.includes('culture')
  ) {
    return find('culture');
  }
  return undefined;
}

export function getCategoryUrl(category?: string): string {
  return getCategoryForPost(category)?.path ?? '/blog';
}
